var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgButtonCloseLargeWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 56 56"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 144578",
  fill: "none",
  d: "M0 0h56v56H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.999 30.029l-13.52 13.523a1.416 1.416 0 01-1 .437 1.37 1.37 0 01-1.027-.437 1.4 1.4 0 01-.449-1.015 1.4 1.4 0 01.449-1.015l13.52-13.521-13.52-13.523a1.416 1.416 0 01-.437-1 1.37 1.37 0 01.437-1.027 1.4 1.4 0 011.015-.449 1.4 1.4 0 011.015.449l13.52 13.52 13.521-13.52a1.416 1.416 0 011-.437 1.37 1.37 0 011.027.437 1.4 1.4 0 01.449 1.015 1.4 1.4 0 01-.449 1.015l-13.52 13.52 13.52 13.521a1.416 1.416 0 01.437 1 1.37 1.37 0 01-.437 1.027 1.4 1.4 0 01-1.015.449 1.4 1.4 0 01-1.015-.449z",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/button-close-large-white.d3bd6f94dc3620fb66e7cb046f3a510f.svg";
export { SvgButtonCloseLargeWhite as ReactComponent };